import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

let BarChart = {
  extends: Bar,
  name: 'Chart',
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  // data() {
  //   return {
  //     options: {
  //       //Chart.js options
  //       scales: {
  //         yAxes: [
  //           {
  //             ticks: {
  //               beginAtZero: true
  //             },
  //             gridLines: {
  //               display: true
  //             }
  //           }
  //         ],
  //         xAxes: [
  //           {
  //             gridLines: {
  //               display: false
  //             }
  //           }
  //         ]
  //       },
  //       legend: {
  //         display: true
  //       },
  //       responsive: true,
  //       maintainAspectRatio: false
  //     }
  //   }
  // },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}

export { BarChart as default }
